import { useMemo } from 'react'

import { useFeatureFlag } from 'src/contexts/FeatureFlagContext'
import { usePreparedInconsistencies } from 'src/contexts/InlineInconsistenciesContext'
import { NO_INCONSISTENCIES, getParagraphInconsistencies, getParagraphWindow } from 'src/models/InlineInconsistency'
import { TranscriptParagraph } from 'src/models/Transcript'

type ParagraphTimes = Pick<TranscriptParagraph, 'startTime' | 'endTime'>

export const useParagraphInconsistencies = (paragraph: ParagraphTimes | undefined, previous: ParagraphTimes | undefined) => {
    const isEnabled = useFeatureFlag('insights_inline_inconsistencies')
    const prepared = usePreparedInconsistencies()
    const paragraphWindow = paragraph ? getParagraphWindow(paragraph, previous) : null
    const from = paragraphWindow?.from
    const to = paragraphWindow?.to

    return useMemo(
        () => (isEnabled && from !== undefined && to !== undefined ? getParagraphInconsistencies(prepared, from, to) : NO_INCONSISTENCIES),
        [isEnabled, prepared, from, to],
    )
}
